import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getSalesPersonData } from "@/lib/get-sales-person-data";
import { getAdsProperties, storeIdentifiers } from "@/lib/identifiers";
import { getTrackingKey } from "@/lib/monitoring/oci";
import { rudderanalytics } from "@/lib/rudderstack";

export const EventTracking = () => {
  const location = useLocation();

  const storeIdentifiersAndTrackEvent = async () => {
    await storeIdentifiers();
  };

  useEffect(() => {
    getSalesPersonData();
    storeIdentifiersAndTrackEvent();
    getTrackingKey();
  }, []);

  const sendPageEvent = async () => {
    const { pathname, search } = location;
    const fullUrl = window.location.origin + pathname + search;
    const properties = await getAdsProperties();

    rudderanalytics.page(pathname, {
      path: pathname,
      url: fullUrl,
      title: document.title,
      referrer: document.referrer,
      ...properties,
    });
  };

  useEffect(() => {
    sendPageEvent();
  }, [location]);

  return null;
};
